export default "__VITE_ASSET__0813e574__"